import { render } from "./NoteTemplates.vue?vue&type=template&id=47ae2d4c"
import script from "./NoteTemplates.vue?vue&type=script&lang=js"
export * from "./NoteTemplates.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__